import React, { useEffect } from "react";
import { Rept } from "../../../../Context/InshData";
import Grid from "@material-ui/core/Grid";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import MaterialTable from "material-table";
import { stElemnt } from "../../../../St/Reviews/cStyle";

import { colors, Container, makeStyles, Typography } from "@material-ui/core";

export function Totals({ data }) {
  const cls = useRptAF();
  return (
    <Grid
      container
      lg={12}
      md={12}
      className={cls.rootBdydown}
      style={{ paddingBottom: 5, backgroundColor: colors.grey[100], fontFamily: "Amiri-Regular" }}
    >
      <Grid container xs={12} /*className={cls.rootchip}*/ style={{
        paddingBottom: 5,
        backgroundColor: colors.grey[100], fontFamily: "Amiri-Regular",
        border: "solid 1px",
        padding: "0.3rem 0.1rem 0.3rem 0.1rem",
        borderRadius: "0px 0px 5px 0px"
      }}>

        <Grid item xs={3} className={[cls.chipVMU]}>
          {"إجمالي عدد الأصناف"}
        </Grid>
        <Grid item xs={2} className={[cls.chipVMU]}>
          {Rept.tot.totval}
        </Grid>
        <Grid item xs={3} className={[cls.chipVMU]}>
          {"إجمالي التكلفة"}
        </Grid>
        <Grid item xs={2} className={[cls.chipVMU]}>
          {Rept.tot.totTaqlfa}
        </Grid>
      </Grid>

    </Grid>
  );
}
function BodyJard({ data, isFullPage, isLast }) {
  const cls = useRptAF();

  const cellS = {

    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "normal",
    border: "solid 0.1px",
    fontSize: "0.65rem",
    width: "300px",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
  };
  const cellSDel = {
    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    border: "solid 0.1px",
    fontSize: "0.7rem",
    maxWidth: "300px",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
  };
  var columns = [
    // { title: "#", field: "no" },
    { title: "الباركود", field: "barcode" },
    { title: "الصنف", field: "Name_Item", cellStyle: cellSDel },
    { title: "الرصيد", field: "Balance" },
    { title: "متوسط التكلفة", field: "cost" },
    { title: "إجمالي التكلفة", field: "sumCost_item" },
    { title: "إجمالي الوارد", field: "Income" },
    { title: "إجمالي المباع", field: "Outcome" },
  ];

  var columns2 = [
    { title: "رقم الباركود", field: "barcode" },
    { title: "الصنف", field: "Name_Item", cellStyle: cellSDel },
    { title: "الرصيد", field: "Balance" },
    { title: "Group", field: "Name_Group" },
    { title: "متوسط التكلفة", field: "cost" },
    { title: "إجمالي التكلفة", field: "sumCost_item" },
  ];

  const data2 = data.map((row) => {
    return {
      ...row,
      balance: parseFloat(row.balance).toFixed(2),
      cost: parseFloat(row.cost).toFixed(2),
      sumCost_item: parseFloat(row.sumCost_item).toFixed(2),
      Income: parseFloat(row.Income).toFixed(2),
      Outcome: parseFloat(row.Outcome).toFixed(2),
    };
  });


  return (
    <Grid item container style={{ fontFamily: "Amiri-Regular" }}>
      <Grid item container style={{ direction: "rtl", paddingTop: "0.7rem" }}>
        <Grid
          item
          xs={12}
        >
          <MaterialTable
            style={{ boxShadow: "none" }}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              // ToolBar Search
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,

              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom: "2px",
                border: "solid 0px",
                border: "solid 0.1px",


              },
              paging: false,
              // headerStyle: { ...stElemnt.AF.header, backgroundColor: "grey" },
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
                // fontSize: 8,
              },
              // maxBodyHeight: isFullPage ? "56.3rem" : "35.6rem",
              // minBodyHeight: isFullPage ? "56.3rem" : "35.6rem",
            }}
            localization={{
              body: {
                emptyDataSourceMessage: (
                  <h5 style={{ color: "GrayText" }}>
                    لا توجد ارصدة بعد في هذا الحساب
                  </h5>
                ),
              },
            }}
            columns={Rept.kind == 2 ? columns2 : columns}
            data={data2}
          />
          {isLast && <Totals data={data ?? []} />}
        </Grid>
        {/* <Grid item xs={12}>
        </Grid> */}
      </Grid>


    </Grid>
  );
}

export default BodyJard;
